import { EMAIL_REGEXP } from '@/components/Event/NewScript/schemas/attendeeSchema'
import { DRScriptData, ScriptAttendee } from '@/types'

const hasIncompleteEmail = (attendees: ScriptAttendee[] | undefined): boolean =>
  (attendees ?? []).some(attendee => {
    // Parrot trims on its side, so surrounding whitespace must not hold the
    // draft back.
    const email = attendee?.email?.trim()

    return !!email && !EMAIL_REGEXP.test(email)
  })

/**
 * Whether the draft save would be accepted. Parrot types the attendee e-mail as
 * EmailStr, so an address the reporter is still typing makes the whole payload
 * invalid and every keystroke 422s. Script state keeps the in-progress value —
 * only the upload waits for it to become a complete address, or empty again.
 */
export const isUploadableScriptData = (state: DRScriptData): boolean =>
  !hasIncompleteEmail(state?.attendees) &&
  !(state?.events ?? []).some(event => hasIncompleteEmail(event?.attendees))
